 <template>
    <el-date-picker
        v-model="bindValue"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        :size="size"
        :picker-options="pickerOptions"
        placeholder="选择时间范围"
        range-separator=" ~ "
        align="right"
        @change="updateValue"
        ref="datetime">
    </el-date-picker>
 </template>
 <script>
    export default {
        name: 'LyDatetimePicker',
        props: {
            value: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: 'small'
            }
        },
        data () {
            return { 
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '最近一个月',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '最近三个月',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }]
                },
                bindValue: '',
            }
        },
        mounted () {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            // 初始化设置默认时间为一周类
            this.bindValue = [start, end]
            this.updateValue([start.format("yyyy-MM-dd hh:mm:ss"), end.format("yyyy-MM-dd hh:mm:ss")])
        },
        methods: {
            updateValue: function (value) {
                if (Array.isArray(value)) {
                    value = value.join('~')
                }
                if (this.value !== value) {
                    this.$emit('input', value)
                }
            },
            /**
             * 获得当前时间
             * @return {[type]} [description]
             */
            getFormatDate (date) {
                if (date) {
                    var seperator = "-";
                    var month = date.getMonth() + 1;
                    var strDate = date.getDate();
                    if (month >= 1 && month <= 9) {
                        month = "0" + month;
                    }
                    if (strDate >= 0 && strDate <= 9) {
                        strDate = "0" + strDate;
                    }
                    var currentdate = date.getFullYear() + seperator + month + seperator + strDate
                    return currentdate
                }
            }
        }
    }
 </script>